export default "__VITE_ASSET__B$6Cb55Z__"